import React, { useEffect, useState } from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import { selectInquiryDeleteEvent } from 'Store/delivery-cost/selector'
import { AppInput } from 'Components/form'
import { MyTheme } from 'Components/common/Theme'
import styled from 'styled-components'
import { StockConfigData, StockProductConfig } from 'Store/stock/types'
import { cloneDeep } from 'lodash'
import ProductsTable from './ProductsTable'

type Props = {
  data: StockConfigData
  onUpdate: (data: StockConfigData) => void
  addProduct?: boolean
  disableProduct?: StockProductConfig[]
} & ReduxProps

const ConfigForm: React.FunctionComponent<Props> = props => {
  const { onUpdate, data, addProduct = false, disableProduct = [] } = props

  const [formData, setFormData] = useState(cloneDeep(data))

  useEffect(() => {
    if (data) {
      setFormData(data)
    }
  }, [data])

  const onUpdateData = (val: any, key: string) => {
    onUpdate({
      ...formData,
      [key]: val,
    })
  }

  const configPoint = (
    <Row gutter={[32, 24]} justify="start" align="middle">
      <Col md={24} xs={24} className="ttr-qty">
        <Title>จำนวนการแจ้งเตือนขั้นต่ำของสต๊อก</Title>
        <Row gutter={[12, 12]}>
          <Col md={24} xs={24}>
            <AppInput
              label={''}
              name={'min_qty'}
              value={formData?.min_qty}
              isRequired={true}
              isError={false}
              onChange={onUpdateData}
              type="number"
              placeHolder="ระบุจำนวน"
              resProps={{
                suffix: 'หน่วย',
                min: 0,
                allowClear: false,
              }}
            />
          </Col>
        </Row>
      </Col>
    </Row>
  )

  const configProduct = (
    <Row gutter={[8, 24]} justify="start" align="middle" className="ttr-product">
      <Col span={24}>
        <Title>สินค้า</Title>
        <ProductsTable
          products={formData?.products || []}
          onUpdateData={(product: StockProductConfig[]) => {
            onUpdateData(product, 'products')
          }}
          disableProduct={disableProduct}
        />
      </Col>
    </Row>
  )

  const configForm = (
    <ConfigWrapper>
      <Row gutter={[32, 24]} justify="start" align="top">
        <Col md={12} xs={24}>
          {configPoint}
        </Col>
        {addProduct && (
          <Col md={24} xs={24}>
            {configProduct}
          </Col>
        )}
      </Row>
    </ConfigWrapper>
  )

  return configForm
}

const Title = styled.div`
  margin-bottom: 10px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

const ConfigWrapper = styled.div`
  width: 100%;
  //padding-left: 40px;
  border-radius: 5px;
  padding: 10px 10px;
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectInquiryDeleteEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ConfigForm)
